import { render } from "./BlackButton.vue?vue&type=template&id=95383ee4"
import script from "./BlackButton.vue?vue&type=script&lang=js"
export * from "./BlackButton.vue?vue&type=script&lang=js"

import "./BlackButton.vue?vue&type=style&index=0&id=95383ee4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__